import React, { useState } from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import LandingPage   from './pages/LandingPage';
import LoginPage     from './pages/LoginPage';
import RegisterPage  from './pages/RegisterPage';
import PaymentPage   from './pages/PaymentPage';
import DashboardPage from './pages/DashboardPage';
import CalendarPage  from './pages/CalendarPage';
import StarField from './components/StarField';
import { api } from './api/client';

function App() {
  const [token, setToken] = useState(localStorage.getItem('token'));
  const [paid, setPaid]   = useState(localStorage.getItem('paid') === '1');
  const [lang, setLang]   = useState(localStorage.getItem('lang') || 'ru');

  const login = (t, isPaid) => {
    localStorage.setItem('token', t);
    localStorage.setItem('paid', isPaid ? '1' : '0');
    setToken(t);
    setPaid(!!isPaid);
  };
  const markPaid = () => { localStorage.setItem('paid', '1'); setPaid(true); };
  const logout = () => {
    localStorage.removeItem('token');
    localStorage.removeItem('paid');
    localStorage.removeItem('pendingTariff');
    setToken(null);
    setPaid(false);
  };

  const deleteAccount = async () => {
    await api.deleteAccount();
    logout();
  };

  const changeLang = (l) => {
    localStorage.setItem('lang', l);
    setLang(l);
  };

  // Есть токен, но оплата ещё не подтверждена — всегда на страницу оплаты
  const homeRedirect = !token ? null : (paid ? '/dashboard' : '/payment');

  return (
    <>
    <StarField />
    <div style={{ position: 'relative', zIndex: 1 }}>
    <Routes>
      <Route
        path="/"
        element={homeRedirect ? <Navigate to={homeRedirect} /> : <LandingPage lang={lang} onLangChange={changeLang} />}
      />
      <Route path="/login"    element={!token ? <LoginPage    onLogin={login} lang={lang} /> : <Navigate to={homeRedirect} />} />
      <Route path="/register" element={!token ? <RegisterPage onLogin={login} lang={lang} /> : <Navigate to={homeRedirect} />} />
      <Route path="/free"          element={<DashboardPage free lang={lang} />} />
      <Route path="/free-calendar" element={<CalendarPage mode="free" lang={lang} />} />
      <Route path="/demo"          element={<CalendarPage mode="demo" lang={lang} />} />
      <Route path="/payment"  element={token ? <PaymentPage paid={paid} onPaid={markPaid} onLogout={logout} onDelete={deleteAccount} lang={lang} /> : <Navigate to="/" />} />
      <Route path="/dashboard" element={token && paid ? <DashboardPage onLogout={logout} onDelete={deleteAccount} lang={lang} /> : <Navigate to={homeRedirect || '/'} />} />
      <Route path="/calendar"  element={token && paid ? <CalendarPage  onLogout={logout} lang={lang} /> : <Navigate to={homeRedirect || '/'} />} />
      <Route path="*" element={<Navigate to={homeRedirect || '/'} />} />
    </Routes>
    </div>
    </>
  );
}

export default App;
